
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcIntegrationDropdownButton as ObcIntegrationDropdownButtonElement} from '@oicl/openbridge-webcomponents/dist/integration-systems/integration-dropdown-button/integration-dropdown-button.js';
 import {ObcIntegrationDropdownButtonChangeEvent} from '@oicl/openbridge-webcomponents/dist/integration-systems/integration-dropdown-button/integration-dropdown-button.js';
 export type {ObcIntegrationDropdownButtonChangeEvent} from '@oicl/openbridge-webcomponents/dist/integration-systems/integration-dropdown-button/integration-dropdown-button.js';
 

 
 export const ObcIntegrationDropdownButton = createComponent({
   react: React,
   tagName: 'obc-integration-dropdown-button',
   elementClass: ObcIntegrationDropdownButtonElement,
   events: {
     
     onChange: 'change' as EventName<ObcIntegrationDropdownButtonChangeEvent>,
   }
  });
 
 